import { observable, action, makeObservable, computed } from "mobx";
import { getMobileOrderNo } from "utils/Utils";

class EndOrderStore {
  constructor() {
    makeObservable(this);
  }

  /**
   * 지난 주문 내역 페이징 객체
   * @type {{end_page_no: number, end_max_page: number}}
   * @private
   */
  @observable
  _st_end_order_paging = {
    end_page_no: 1,
    end_max_page: 1,
  };

  @computed
  get getEndOrderPaging() {
    return this._st_end_order_paging;
  }

  /**
   * 지난주문 내역  페이징 객체 값 셋팅
   * @param key
   * @param value
   */
  @action
  setEndOrderPagingInfo(key, value) {
    this._st_end_order_paging = { ...this._st_end_order_paging, [key]: value };
  }

  /**
   * 지난주문 내역  다음페이지 이동
   */
  @action
  nextEndOrderPage() {
    const max_page = this._st_end_order_paging.end_max_page;
    let page_no = this._st_end_order_paging.end_page_no;

    if (page_no < max_page) {
      this._st_end_order_paging.end_page_no = page_no + 1;
    }
  }

  /**
   * 지난주문 내역 이전페이징 이동
   */
  @action
  prevEndOrderPage() {
    let page_no = this._st_end_order_paging.end_page_no;
    if (page_no > 1) {
      this._st_end_order_paging.end_page_no = page_no - 1;
    }
  }

  /**
   * 지난주문 내역 레이어 열고 닫기
   * @type {{detail_area_view: boolean, key_area_view: boolean}}
   * @private
   */
  @observable
  _st_end_order_search_view = {
    key_area_view: false,
    detail_area_view: false,
  };

  @computed
  get getEndOrderSearchView() {
    return this._st_end_order_search_view;
  }

  @action
  setEndOrderSearchView(key, value) {
    this._st_end_order_search_view = { ...this._st_end_order_search_view, [key]: value };
  }

  @action
  initEndOrderSearchView() {
    this._st_end_order_search_view = {
      key_area_view: false,
      detail_area_view: false,
    };
  }

  /**
   * 검색 키값
   * @type {string}
   * @private
   */
  @observable
  _st_end_search_key_val = {
    key: "mobileOrderNo",
    val: "채널 주문번호",
  };

  @computed
  get getEndSearchKeyVal() {
    return this._st_end_search_key_val;
  }

  @action
  setSearchKeyVal(key, val) {
    this._st_end_search_key_val = { key: key, val: val };
  }

  @action
  initSearchKeyVal(key, val) {
    this._st_end_search_key_val = {
      key: "mobileOrderNo",
      val: "채널 주문번호",
    };
  }

  /**
   * 상세검색 버튼
   * @type {{delivery: boolean, niceorder: boolean, coupang: boolean, yogiyo: boolean, pickup: boolean, naver: boolean, baemin: boolean, order_s: boolean, morder: boolean, paid: boolean, paid_cash: boolean, order_e: boolean, paid_card: boolean, table: boolean, wemakeo: boolean}}
   * @private
   */
  @observable
  _st_detail_button_view = {
    item: {
      delivery: false, // 배달
      pickup: false, // 픽업
      table: false, // 테이블
      baemin: false, // 배민
      coupang: false, // 쿠팡
      yogiyo: false, // 요기요
      naver: false, // 네이버
      naverBooking: false, // 네이버 예약
      naverConnect: false, // Npay 커넥트
      niceorder: false, // 나이스오더
      wemakeo: false, // 위메이크오
      morder: false, // 엠오더
      etc: false, // 기타 ( 현재는 08 원토스후킹 )
      cid: false,
      wmpo: false,
      specialdelivery: false, // 배달특급
      ddangyo: false, // 땡겨요
      ddangbaedal: false, // 땡배달
      mukkebi: false, // 먹깨비
      daeguro: false, // 대구로
      incheoneum: false, // 인천이음
      baedalys: false, // 배달양산
      baeminstore: false, // 배민스토어
      bmsmile: false, // 비엠스마일
      panda: false, // 헝그리판다
      pos: false,
      kiosk: false,
      okdc: false,
      qrorder: false,
      paid: false, // 선불
      paid_card: false, // 후불카드
      paid_cash: false, // 후불현금
      paid_complex: false, // 후불복합
      order_s: false, // 완료
      order_e: false, // 취소
    },
    beforeItem: {
      delivery: false, // 배달
      pickup: false, // 픽업
      table: false, // 테이블
      baemin: false, // 배민
      coupang: false, // 쿠팡
      yogiyo: false, // 요기요
      naver: false, // 네이버
      naverBooking: false, // 네이버 예약
      naverConnect: false, // Npay 커넥트
      niceorder: false, // 나이스오더
      wemakeo: false, // 위메이크오
      morder: false, // 엠오더
      etc: false, // 기타 ( 현재는 08 원토스후킹 )
      cid: false,
      wmpo: false,
      specialdelivery: false, // 배달특급
      ddangyo: false, // 땡겨요
      ddangbaedal: false, // 땡배달
      mukkebi: false, // 먹깨비
      daeguro: false, // 대구로
      incheoneum: false, // 인천이음
      baedalys: false, // 배달양산
      baeminstore: false, // 배민스토어
      bmsmile: false, // 비엠스마일
      panda: false, // 헝그리판다
      pos: false,
      kiosk: false,
      okdc: false,
      qrorder: false,
      paid: false, // 선불
      paid_card: false, // 후불카드
      paid_cash: false, // 후불현금
      paid_complex: false, // 후불복합
      order_s: false, // 완료
      order_e: false, // 취소
    },
  };

  @computed
  get getDetailButtonView() {
    return this._st_detail_button_view.item;
  }

  @action
  setDetailButtonView(key, value) {
    const newItem = { ...this._st_detail_button_view.item, [key]: value };

    // 네이버 채널 선택 시 naverBooking, naverConnect도 함께 선택/해제
    if (key === "naver") {
      newItem.naverBooking = value;
      newItem.naverConnect = value;
    }

    // 땡겨요 채널 선택 시 땡배달 함께 처리
    if (key === "ddangyo") {
      newItem.ddangyo = value;
      newItem.ddangbaedal = value;
    }

    return (this._st_detail_button_view.item = newItem);
  }

  @action
  setBeforeDetailUpdate() {
    this._st_detail_button_view.item = this._st_detail_button_view.beforeItem;
  }
  @action
  setAfterDetailUpdate() {
    this._st_detail_button_view.beforeItem = this._st_detail_button_view.item;
  }

  @action
  initDetailButtonView() {
    this._st_detail_button_view.item = {
      delivery: false, // 배달
      pickup: false, // 픽업
      table: false, // 테이블
      baemin: false, // 배민
      coupang: false, // 쿠팡
      yogiyo: false, // 요기요
      naver: false, // 네이버
      naverBooking: false, // 네이버 예약
      naverConnect: false, // Npay 커넥트
      niceorder: false, // 나이스오더
      wemakeo: false, // 위메이크오
      morder: false, // 엠오더
      etc: false,
      cid: false,
      wmpo: false,
      specialdelivery: false, // 배달특급
      ddangyo: false, // 땡겨요
      ddangbaedal: false, // 땡배달
      mukkebi: false, // 먹깨비
      daeguro: false, // 대구로
      incheoneum: false, // 인천이음
      baedalys: false, // 배달양산
      baeminstore: false, // 배민스토어
      bmsmile: false, // 비엠스마일
      panda: false, // 헝그리판다
      pos: false,
      kiosk: false,
      okdc: false,
      qrorder: false,
      paid: false, // 선불
      paid_card: false, // 후불카드
      paid_cash: false, // 후불현금
      paid_complex: false, // 후불복합
      order_s: false, // 완료
      order_e: false, // 취소
    };
    this._st_detail_button_view.beforeItem = {
      delivery: false, // 배달
      pickup: false, // 픽업
      table: false, // 테이블
      baemin: false, // 배민
      coupang: false, // 쿠팡
      yogiyo: false, // 요기요
      naver: false, // 네이버
      naverBooking: false, // 네이버 예약
      naverConnect: false, // Npay 커넥트
      niceorder: false, // 나이스오더
      wemakeo: false, // 위메이크오
      morder: false, // 엠오더
      etc: false,
      cid: false,
      wmpo: false,
      specialdelivery: false, // 배달특급
      ddangyo: false, // 땡겨요
      ddangbaedal: false, // 땡배달
      mukkebi: false, // 먹깨비
      daeguro: false, // 대구로
      incheoneum: false, // 인천이음
      baedalys: false, // 배달양산
      baeminstore: false, // 배민스토어
      bmsmile: false, // 비엠스마일
      panda: false, // 헝그리판다
      pos: false,
      kiosk: false,
      okdc: false,
      qrorder: false,
      paid: false, // 선불
      paid_card: false, // 후불카드
      paid_cash: false, // 후불현금
      paid_complex: false, // 후불복합
      order_s: false, // 완료
      order_e: false, // 취소
    };
  }

  /**
   * 지난주문 내역 검색어
   * @type {string}
   * @private
   */
  @observable
  _st_end_search_val = "";

  @computed
  get getEndSearchVal() {
    return this._st_end_search_val;
  }

  @action
  setEndSearchVal(val) {
    this._st_end_search_val = val;
  }

  /**
   * 상단 날짜 버튼 관리
   * @type {string}
   * @private
   */
  @observable
  _st_end_date_term = {
    today: true, // 오늘
    three: false, // 3일전
    week: false, // 일주전
  };

  @computed
  get getEndDateTerm() {
    return this._st_end_date_term;
  }

  @action
  setEndDateTerm(key, value) {
    this._st_end_date_term = { ...this._st_end_date_term, [key]: value };
  }

  @action
  initEndDateTerm() {
    this._st_end_date_term = {
      today: true, // 오늘
      three: false, // 3일전
      week: false, // 일주전
    };
  }

  @action
  searchDateTerm() {
    this._st_end_date_term = {
      today: false, // 오늘
      three: false, // 3일전
      week: false, // 일주전
    };
  }

  /**
   * 상단 날짜 버튼별 값
   * @type {string}
   * @private
   */
  @observable
  _st_end_date_term_val = {
    today: new Date(), // 오늘
    three: new Date(Date.parse(new Date()) - 2 * 1000 * 60 * 60 * 24), // 3일전
    week: new Date(Date.parse(new Date()) - 6 * 1000 * 60 * 60 * 24), // 3일전
  };

  @computed
  get getEndDateTermVal() {
    return this._st_end_date_term_val;
  }

  /**
   * 상단 날짜 값
   * @type {{end_val: string, start_val: string}}
   * @private
   */
  @observable
  _st_end_date_val = {
    start_val: new Date(),
    end_val: new Date(),
  };

  @computed
  get getEndDateVal() {
    return this._st_end_date_val;
  }

  @action
  setEndDateVal(key, value) {
    this._st_end_date_val = { ...this._st_end_date_val, [key]: value };
  }

  @action
  initEndDateVal() {
    this._st_end_date_val = {
      start_val: "",
      end_val: "",
    };
  }

  /**
   * 지난 주문 목록 객체 OBJ LIST
   * @type {[]}
   * @private
   */
  @observable
  _st_end_order_list = [];

  /**
   * 지난 주문 목록 조회
   * @returns {[]}
   */
  @computed
  get getEndOrderList() {
    return this._st_end_order_list;
  }

  @action
  setEndOrderList(list) {
    this._st_end_order_list = list.map(order => {
      return this.endShopMessageUpdate(this.endOrderNoCreate(order));
    });
  }

  /**
   * 완료주문 보기 지난 주문 목록 객체 OBJ LIST
   * @type {[]}
   * @private
   */
  @observable
  _st_end_order_complete_list = [];

  /**
   * 완료주문 보기 지난 주문 목록 조회
   * @returns {[]}
   */
  @computed
  get getEndOrderCompleteList() {
    return this._st_end_order_complete_list;
  }

  @action
  setEndOrderCompleteList(list) {
    this._st_end_order_complete_list = list.map(order => {
      return this.endShopMessageUpdate(this.endOrderNoCreate(order));
    });
  }

  /**
   * 상세보기 객체로 리스트 객체 재설정
   * @param viewObj
   */
  @action
  addListByViewObj(viewObj) {
    this._st_end_order_list = this._st_end_order_list.map(order => {
      if (viewObj.mobileOrderNo === order.mobileOrderNo) {
        return viewObj;
      } else {
        return order;
      }
    });
  }

  @action
  initEndOrderList() {
    this._st_end_order_list = [];
  }

  endShopMessageUpdate(order) {
    if (order.shopMessage != null) {
      let message = order.shopMessage.replace(/`/g, "").substring(order.shopMessage.indexOf("제]")).split("|");
      if (
        order.mobileOrderFg === "08" ||
        order.mobileOrderFg === "22" ||
        order.mobileOrderFg === "25" ||
        order.mobileOrderFg === "26"
      ) {
        if (order.shopMessage) {
          return { ...order, shopMessage: message[0], dlvMessage: message[1] };
        }
      } else {
        return { ...order, shopMessage: message[0] };
      }
    } else {
      return order;
    }
  }

  endOrderNoCreate(order) {
    return getMobileOrderNo(order);
  }
}

export default new EndOrderStore();
